/**
 * @fileoverview Context provider for table-related state management.
 * This file creates a React context for managing table state like selected rows and column widths.
 * @see {/src/components/companies/companiesList/newCompaniesList/types.ts}
 * @active
 */

"use client";

import { createContext } from "react";

import { type TableContextType } from "../../types";

/**
 * @constant defaultContext
 * @description Default values for TableContext
 * @type {TableContextType}
 * @active
 */
const defaultContext: TableContextType = {
  selectedRows: [],
  setSelectedRows: () => {},
  columnsWidth: [],
  initialColumnsWidth: [],
  setInitialColumnsWidth: () => {},
};

/**
 * @constant TableContext
 * @description React context for table state management
 * @type {React.Context<TableContextType>}
 * @active
 */
const TableContext = createContext<TableContextType>(defaultContext);

export default TableContext;
